import { useEffect } from 'react';
import { useHistory } from 'umi';
import { useLatest } from 'ahooks';
import usePageStore from '@gp/hooks/usePageStore';
import { LOCKER_MODEL_NAMESPACE } from '../models/locker';

import type { ILockerData } from '../models/locker';

export default function useDomainPageStore(props: {
  getFilter: () => ILockerData['filter'];
  getSort: () => ILockerData['sort'];
  getSearch: () => ILockerData['search'];
}) {
  const { getFilter, getSort, getSearch } = props;

  const getFilterLatest = useLatest(getFilter);
  const getSortLatest = useLatest(getSort);
  const getSearchLatest = useLatest(getSearch);

  const history = useHistory();

  const { lockerData, setLockerData, clearLockerData } = usePageStore<ILockerData>(LOCKER_MODEL_NAMESPACE);

  const { lock, filter, sort, search } = lockerData || {};

  /**
   * 监听路由页面切换
   * 1、本页面不做任何处理
   * 2、跳转到studio详情页，需要保留当前的页面状态
   * 3、跳转到其他页面时，需要清除已保存的页面状态
   */
  useEffect(() => {
    const unListen = history.listen((location) => {
      const { pathname } = location || {};
      // 本页面不做任何处理
      if (pathname === '/g-pop/Pipeline/ChangeLog/ChangeDetail') return;
      // 跳转到project详情页，需要保留当前的页面状态
      if (pathname === '/g-pop/Pipeline/ProjectList/Detail') {
        setLockerData({
          filter: getFilterLatest.current?.(),
          sort: getSortLatest.current?.(),
          search: getSearchLatest.current?.(),
        });
        return;
      }
      // 否则，需要清除已保存的页面状态
      clearLockerData();
    });

    // 清理监听器
    return () => {
      unListen();
    };
  }, [history]);

  return {
    lock,
    filter,
    sort,
    search,
  };
}
